import IconSingleService from '@apollo/icons/default/IconSingleService.svg';
import {
  Badge,
  Button,
  Group,
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger,
  Text,
} from '@apollo/orbit';
import React from 'react';

import { GraphQLTypes } from 'src/lib/graphqlTypes';

const AddedTag = () => {
  return <Badge variant="success">Added</Badge>;
};
const RemovedTag = () => {
  return <Badge variant="error">Removed</Badge>;
};
const ModifiedTag = () => {
  return <Badge variant="neutralOutlined">Modified</Badge>;
};

export const LaunchUpdatedSubgraphs = ({
  subgraphChanges,
}: {
  subgraphChanges: GraphQLTypes.LaunchDetailsQuery_service_variant_launch_subgraphChanges[];
}) => {
  const ChangeType = {
    ADDITION: <AddedTag />,
    DELETION: <RemovedTag />,
    MODIFICATION: <ModifiedTag />,
  };

  return (
    <div className="mr-2 flex flex-wrap items-center truncate text-sm">
      <IconSingleService className="mr-2 text-icon-primary" />
      <Popover placement="top">
        <PopoverTrigger>
          <Button variant="buttonLink" className="text-sm">
            {subgraphChanges[0]?.name}{' '}
            {subgraphChanges.length > 1 &&
              `+ ${subgraphChanges.length - 1} more`}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto min-w-0">
          <PopoverHeader>Updated subgraphs</PopoverHeader>
          <PopoverBody>
            {subgraphChanges.map((subgraph) => (
              <Group
                key={subgraph.name}
                className="mt-3 justify-between first:mt-0"
                gap={4}
              >
                <Group gap={2}>
                  <IconSingleService className="text-icon-primary" />
                  <Text as="span" size="sm" className="text-neutral">
                    {subgraph.name}
                  </Text>
                </Group>
                {ChangeType[subgraph.type]}
              </Group>
            ))}
          </PopoverBody>
        </PopoverContent>
      </Popover>
    </div>
  );
};
